(function () {
  angular.module("akitabox.ui.components.building", [
    "akitabox.core.toast",
    "akitabox.core.services.building",
    "akitabox.ui.components.typeAheadInput",
  ]);
})();
